import {
  useOrganizationsServiceOrganizationsTeamUsersListKey,
  useOrganizationsServiceOrganizationsTeamUsersPartialUpdate
} from '@organization/api/queries'
import { TeamUsersDetail } from '@organization/api/requests'
import { useInvalidateQueries } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'
import { Form, message, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

import { RoleSelect } from '../Team'

type Props = {
  user?: TeamUsersDetail | null
  onCancel: () => void
}

export const UserRoleInTeam = ({ user, onCancel }: Props) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const { invalidateQueries } = useInvalidateQueries()

  const { mutate, isPending } =
    useOrganizationsServiceOrganizationsTeamUsersPartialUpdate({
      onSuccess: () => {
        message.success(t('users.roles_edited'))
        invalidateQueries([
          useOrganizationsServiceOrganizationsTeamUsersListKey
        ])
        onCancel()
      },
      onError: (error) => showApiErrors(error, form)
    })

  const onSubmit = async () => {
    if (!user?.id) return

    const values = await form.validateFields()

    mutate({ id: user?.id, requestBody: { roles: values.roles } })
  }

  return (
    <Modal
      title={t('modal.change_user_role')}
      open
      onOk={onSubmit}
      onCancel={onCancel}
      destroyOnHidden
      okButtonProps={{
        loading: isPending
      }}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ roles: user?.roles?.map(({ id }) => id) }}
      >
        <Form.Item
          name="roles"
          label={t('form.item.user_role')}
          rules={[
            {
              required: true
            }
          ]}
        >
          <RoleSelect />
        </Form.Item>
      </Form>
    </Modal>
  )
}
